var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-player"},[_c('audio',{ref:"audio",attrs:{"src":_vm.audio,"preload":"metadata"},on:{"ended":function($event){_vm.active = false}}}),_c('default-button',{staticClass:"frame-button audio-button",class:{active: _vm.active},on:{"clicked":_vm.toggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }